export default __webpack_public_path__ + "static/media/emcoLogo.b29f57b1.png";